// Mirrors the backend FunnelDefinitions.
export var SaveFunnelEvents;
(function (SaveFunnelEvents) {
    SaveFunnelEvents["ONB_SAVE_NEXT_POT_TYPE"] = "ONB_SAVE_NEXT_POT_TYPE";
    SaveFunnelEvents["ONB_SAVE_NEXT_PERSONAL_DETAILS"] = "ONB_SAVE_NEXT_PERSONAL_DETAILS";
    SaveFunnelEvents["ONB_SAVE_NEXT_ADDRESS"] = "ONB_SAVE_NEXT_ADDRESS";
    SaveFunnelEvents["ONB_SAVE_NEXT_TAX"] = "ONB_SAVE_NEXT_TAX";
    SaveFunnelEvents["ONB_SAVE_NEXT_ANNUAL_INCOME"] = "ONB_SAVE_NEXT_ANNUAL_INCOME";
    SaveFunnelEvents["ONB_SAVE_NEXT_POT_DETAILS"] = "ONB_SAVE_NEXT_POT_DETAILS";
    SaveFunnelEvents["ONB_SAVE_NEXT_ISA_DECLARATION"] = "ONB_SAVE_NEXT_ISA_DECLARATION";
    SaveFunnelEvents["ONB_SAVE_NEXT_INITIAL_AMOUNT"] = "ONB_SAVE_NEXT_INITIAL_AMOUNT";
    SaveFunnelEvents["ONB_SAVE_NEXT_FREQUENCY"] = "ONB_SAVE_NEXT_FREQUENCY";
    SaveFunnelEvents["ONB_SAVE_NEXT_AUTO_AMOUNT"] = "ONB_SAVE_NEXT_AUTO_AMOUNT";
    SaveFunnelEvents["ONB_SAVE_NEXT_OVERDRAFT"] = "ONB_SAVE_NEXT_OVERDRAFT";
    SaveFunnelEvents["ONB_SAVE_NEXT_FUNDING_ACCOUNT"] = "ONB_SAVE_NEXT_FUNDING_ACCOUNT";
    SaveFunnelEvents["ONB_SAVE_NEXT_REVIEW_CONFIRM"] = "ONB_SAVE_NEXT_REVIEW_CONFIRM";
    SaveFunnelEvents["ONB_SAVE_COMPLETED"] = "ONB_SAVE_COMPLETED";
})(SaveFunnelEvents || (SaveFunnelEvents = {}));
export var InvestFunnelEvents;
(function (InvestFunnelEvents) {
    InvestFunnelEvents["ONB_INVEST_NEXT_ACCOUNT_TYPE"] = "ONB_INVEST_NEXT_ACCOUNT_TYPE";
    InvestFunnelEvents["ONB_INVEST_NEXT_PERSONAL_DETAILS"] = "ONB_INVEST_NEXT_PERSONAL_DETAILS";
    InvestFunnelEvents["ONB_INVEST_NEXT_ADDRESS"] = "ONB_INVEST_NEXT_ADDRESS";
    InvestFunnelEvents["ONB_INVEST_NEXT_TAX"] = "ONB_INVEST_NEXT_TAX";
    InvestFunnelEvents["ONB_INVEST_NEXT_ANNUAL_INCOME"] = "ONB_INVEST_NEXT_ANNUAL_INCOME";
    InvestFunnelEvents["ONB_INVEST_NEXT_TERMS"] = "ONB_INVEST_NEXT_TERMS";
    InvestFunnelEvents["ONB_INVEST_NEXT_ISA_DECLARATION"] = "ONB_INVEST_NEXT_ISA_DECLARATION";
    InvestFunnelEvents["ONB_INVEST_NEXT_ASSET_PICK"] = "ONB_INVEST_NEXT_ASSET_PICK";
    InvestFunnelEvents["ONB_INVEST_NEXT_INITIAL_AMOUNT"] = "ONB_INVEST_NEXT_INITIAL_AMOUNT";
    InvestFunnelEvents["ONB_INVEST_NEXT_COLLECTION_DATE"] = "ONB_INVEST_NEXT_COLLECTION_DATE";
    InvestFunnelEvents["ONB_INVEST_NEXT_AUTO_AMOUNT"] = "ONB_INVEST_NEXT_AUTO_AMOUNT";
    InvestFunnelEvents["ONB_INVEST_NEXT_FUNDING_ACCOUNT"] = "ONB_INVEST_NEXT_FUNDING_ACCOUNT";
    InvestFunnelEvents["ONB_INVEST_NEXT_REVIEW_CONFIRM"] = "ONB_INVEST_NEXT_REVIEW_CONFIRM";
    InvestFunnelEvents["ONB_INVEST_COMPLETED"] = "ONB_INVEST_COMPLETED";
})(InvestFunnelEvents || (InvestFunnelEvents = {}));
export var InvestFunnelChoiceEvents;
(function (InvestFunnelChoiceEvents) {
    InvestFunnelChoiceEvents["ONB_INVEST_TYPE_ISA"] = "ONB_INVEST_TYPE_ISA";
    InvestFunnelChoiceEvents["ONB_INVEST_TYPE_GIA"] = "ONB_INVEST_TYPE_GIA";
    InvestFunnelChoiceEvents["ONB_INVEST_TYPE_JISA"] = "ONB_INVEST_TYPE_JISA";
})(InvestFunnelChoiceEvents || (InvestFunnelChoiceEvents = {}));
